import fetchData from "../utils/HttpClient";
import {IndexResponseInterface} from "../interfaces/core/IndexResponseInterface";
import {BannerInterface} from "../interfaces/core/BannerInterface";

export function getIndex(): Promise<IndexResponseInterface> {
    return fetchData('/api/index')
}

export function getBanners(groupId: number): Promise<BannerInterface[]> {
    return fetchData('/api/banners/' + groupId)
}